import { scrollDetect } from "../utils/ScrollDetector";
import { LinkToScroll } from "../utils/LinkToScroll";
import { PrefillerFields } from "../utils/PrefillerFields";
import { mobileBodyClass } from '../utils/mobileBodyClass';

export default class Controller {
    /* --------------------------------------------------------------------- */
    /* Here you can instanciate common components for every pageController   */
    /* e.g Header, Footer, Newsletter Modal, ...                             */
    /* --------------------------------------------------------------------- */

    constructor() {
        scrollDetect();

        // NOTE: this code is assuming there's just one single leadform in page
        if (document.querySelector(".leadform")) {
            this.importComponents(`LeadForm`).then(
                ({ default: comp }) => new comp()
            );
            this.importComponents(`SelectCourse`).then(
                ({ default: comp }) => new comp()
            );
        }

        // NOTE: this code is assuming there's just one single tabbed-gallery in page
        this.tabbedGalleries();

        this.searchComponent("SideButtons");

        //NOTE: this code is assuming there's just one single cookie-bar in page
        if (document.querySelector(".cookie-bar")) {
            this.importComponents(`CookieBar`).then(
                ({ default: comp }) => new comp()
            );
        }

        //    this.importUtility(`LinkToScroll`).then(({ default: linkToScroll }) => {
        //      linkToScroll();
        //    });
        LinkToScroll();

        //    this.importUtility(`PrefillerFields`).then(({ default: PrefillerFields }) => {
        //      PrefillerFields();
        //    });
        PrefillerFields();

        mobileBodyClass();
    }

    tabbedGalleries() {
        let targetElement = document.querySelector(".c-tabbedgalleries");
        if (targetElement) {
            this.importComponents(`TabbedGalleries`).then(
                ({ default: comp }) => new comp(targetElement)
            );
        }
    }

    callUsBtn() {
        let targetElement = document.querySelector(".c-call-us-cta");
        if (targetElement) {
            this.importComponents(`CallUsComponent`).then(
                ({ default: comp }) => new comp(targetElement)
            );
        }
    }

    searchComponent(componentName) {
        let targetElements = document.querySelectorAll(
            `[data-component="${componentName}"`
        );
        if (targetElements) {
            this.importComponents(componentName).then(({ default: comp }) => {
                targetElements.forEach(el => {
                    new comp(el);
                });
            });
        }
    }

    /* --------------------------------------------------------------------- */
    /* this method import a module and returns the import promise            */
    /* with this method we centralize the dynamic import                     */
    /* --------------------------------------------------------------------- */
    async importComponents(componentName) {
        return await import(
            /* webpackChunkName:`component-[request]` */
            /* webpackMode: "lazy" */
            `../components/${componentName}`
        );
    }

    /* --------------------------------------------------------------------- */
    /* this method import a module and returns the import promise            */
    /* with this method we centralize the dynamic import                     */
    /* --------------------------------------------------------------------- */
    async importUtility(utilityName) {
        return await import(
            /* webpackChunkName:`utility-[request]` */
            /* webpackMode: "lazy" */
            `../utils/${utilityName}`
        );
    }
}
